import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { MissingTranslationHandler, TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { Console } from 'console';
import { Observable, of, Subject } from 'rxjs';
import { CommentComponent } from 'src/app/lookups/_forme/comment/comment.component';
import { IzmeniKomitentaComponent } from 'src/app/lookups/_forme/izmeni-komitenta/izmeni-komitenta.component';
import { BaseDataService, BaseEntity, BaseTabsContainer, ConfigService, ConfirmationDialogButtons, DefaultListTabsComponent, ErrorHandlerService, LoaderService, ModalService, ModalSize, ModelData, ModelDataService, NotificationService, QueryParameter, TableContextMenu, TableContextMenuItem, TabsContainerService, UserService } from 'yt-ng-framework';
import { FilterWithKomitentComponent } from '../_filters/filter-with-komitent.component';
import { ProveraPosiljaoca } from './provera-posiljaoca/provera-posiljaoca';
import { UlazniDokumentDobavljaca } from './ulazni-dokument-dobavljaca';
import { UlazniDokumentDobavljacaView } from './ulazni-dokument-dobavljaca-view';
import { Prilog } from './prilog';
import { saveAs } from 'file-saver';
// import { ToastrService } from 'ngx-toastr';
import { List } from 'immutable';
import { TrosakDokumentView } from 'src/app/fak/trosak/trosak-dokument-view';

@Component({
  selector: "yt-ulazni-dokument-dobavljaca-tabs",
  templateUrl: "./ulazni-dokument-dobavljaca-tabs.component.html",
  providers: [TabsContainerService],
})
export class UlazniDokumentDobavljacaTabsComponent
  extends BaseTabsContainer<UlazniDokumentDobavljacaView>
  implements OnInit
{
  // pdfSrc = null;
  pdfSrc="assets/pdfs/blank.pdf";

  @ViewChild("filterFak", { static: false }) filterFak: FilterWithKomitentComponent;
  @ViewChild("defaultList", { static: false })
  defaultList: DefaultListTabsComponent<UlazniDokumentDobavljacaView>;

  // @Input() CheckInputDocumentAndRefreshStatusClicked() {}

  base64Data;

  fileReader = new FileReader();
  pdfData;
  osvezavanjeUToku=false;
  poslednjiSelektovaniRacun=null;
  loading: boolean = false;

  constructor(
    public tabsContainerService: TabsContainerService<UlazniDokumentDobavljacaView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected httpClient: HttpClient,
    protected configService: ConfigService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected errorService: ErrorHandlerService,
    protected modelDataService: ModelDataService

  ) {
    super(tabsContainerService, activatedRoute, userService);
  }

  // private _emittedItemSubscription: Subscription;

  printPDF(): void {
    const pdfWindow = window.open("");
    pdfWindow.document.writeln(
      "<iframe width='100%' height='100%' src='" + this.pdfSrc + "'></iframe>"
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  async checkInputDocumentAndRefreshStatus(oldToDays: number) {
    // this.osvezavanjeUToku=true;      
    let __this=this;
    let odDana = new Date();
    let doDana = new Date();
    let proveraIDs : boolean = false;
    var nastalaJeGreska=false;

    const selectedState = this.defaultList.GetMainSelectionState();

    this.filterFak.filterFormGroup.disable();
    this.filterFak.loadingFilter = true;
    this.loading = true;

    odDana.setDate(odDana.getDate() - oldToDays);

    if (this.defaultList.mainItems != null)
    {
       const itemsZaOsvezavanje = this.defaultList.mainItems.filter(value => {
          const d = value["Datum"];
          const jsDate = new Date(d["year"], d["month"] - 1, d["day"]); // i ovo je 00:00
          return jsDate >= odDana;   // ovde gledaš samo od tog datuma pa naviše
        });

        let fak_ids: string = "";
        for (const value of itemsZaOsvezavanje) {
          const jsDate = new Date(
            value["Datum"]["year"],
            value["Datum"]["month"] - 1,
            value["Datum"]["day"]
          );

          fak_ids += (fak_ids ? "," : "") + value.EdokumentID;

          try {
            await __this.OsveziStatus(value["ID"], true);
            console.log("OsveziStatus");
          } 
          catch (error) {
            nastalaJeGreska=true;
            console.log("nastalaJeGreska"+ value["ID"].toString());
          }
       
      };

      if (nastalaJeGreska)
        this.translateService.get('EOTPREMNICA.STATUS.NEMOZEDAOSVEZI')
        .subscribe(translate => {
          window.alert(translate);
        })

      // this.defaultList.mainItems.forEach(function (value) {
      //   const jsDate = new Date(
      //     value["Datum"]["year"],
      //     value["Datum"]["month"] - 1,
      //     value["Datum"]["day"]
      //   );
      //   if (jsDate > odDana)
      //   {
      //     __this.OsveziStatus(value["ID"], true);
         
      //   };        
      // });
      
      __this.GetNewPurchaseDocuments(odDana, doDana, fak_ids)
      .subscribe((value)=>{
        proveraIDs = value;
        if(proveraIDs){
          __this.filterFak.StatusRefreshTime=new Date();
          __this.filterFak.loadingFilter = false;
          __this.loading = false;
          __this.filterFak.SetStatusDescription();
          __this.filterFak.collapsed1=true;
          __this.filterFak.filterFormGroup.enable();
          // __this.tabsContainerService.EmitItem(selectedItem);
           setTimeout(() => {
            __this.defaultList.RestoreMainSelection(selectedState.id, selectedState.index);
          }, 0);
        }
      })
      
    }
   
  }

  
  GetNewPurchaseDocuments(odDana:Date, doDana:Date, fak_ids:string): Observable<boolean>{
    this.osvezavanjeUToku=true;
    var subject = new Subject<boolean>();
    let odDana1: NgbDate = new NgbDate(odDana.getFullYear(), odDana.getMonth() + 1, odDana.getDate());
    let doDana1: NgbDate = new NgbDate(doDana.getFullYear(), doDana.getMonth() + 1, doDana.getDate());
   
        this.baseDataService
        .Post("UlazniDokumentDobavljaca", "GetPurchaseIds", {'DateFrom' : odDana1, 'DateTo' : doDana1, 'FakIds' : fak_ids}, UlazniDokumentDobavljacaView)
        .subscribe((data: UlazniDokumentDobavljacaView[]) => {
          let brojNovihUlaznih : Number = data.length;
          let brojNovihKomitenata: number = data.filter(item => item.NoviKomitent == true).length;
          if (data != null){
            // data.forEach(item => 
            //   this.tabsContainerService.EmitItem(item)
            // );  
            data.forEach(item => 
              this.defaultList.AddOrUpdateMainItemWithoutSelectionChange(item)
            );               
            this.osvezavanjeUToku=false;
            this.SelektovanRacun(this.poslednjiSelektovaniRacun);
          }   
          this.translateService.get(['ULAZNIDOKUMENTDOBAVLJACA.BROJNOVIHULAZNIH.TITLE', 'ULAZNIDOKUMENTDOBAVLJACA.BROJNOVIHKOMITENATA.TITLE']) 
          .subscribe(translate => {
            // this.notificationService.info(translate['ULAZNIDOKUMENTDOBAVLJACA.BROJNOVIHULAZNIH.TITLE'],
            //    brojNovihUlaznih.toString());
            this.toastrService.info(translate['ULAZNIDOKUMENTDOBAVLJACA.BROJNOVIHULAZNIH.TITLE'],
              brojNovihUlaznih.toString());
            if (brojNovihKomitenata>0)             
              this.modalService.ShowConfirmationDialog("Novi komitenti",translate['ULAZNIDOKUMENTDOBAVLJACA.BROJNOVIHKOMITENATA.TITLE']+": "+brojNovihKomitenata.toString(),"info", ConfirmationDialogButtons.Ok)
            subject.next(true);    
          })
          // subject.next(true);    
        }     
    
 , error => {
    this.filterFak.loadingFilter = false;
    this.loading = false;
    let _message;   
    let translatedMessage: string = "";     
    if(error instanceof HttpErrorResponse){
      _message = this.errorService.getServerMessage(error);           
      _message = "FW.ERRORS." + _message;
      this.translateService.get(_message)
      .subscribe(translate => {
        this.modalService.ShowConfirmationDialog("Problemi kod slanja", translate, "warning", ConfirmationDialogButtons.Ok);
      });
    }
 }
)
    return subject.asObservable();
  }

  applayFilter(data) {
    this.defaultList.LoadMainItems(true, data);
  }

  private addOrUpdateMainItemBezSelekcije(item: any): void {
    if (!item || !this.defaultList) {
      return;
    }

    if (!this.defaultList.mainItems) {
      return;
    }

    const index = this.defaultList.mainItems.findIndex(x => x.ID === item.ID);

    if (index >= 0) {
      const oldItem: any = this.defaultList.mainItems.get(index);

      item.Selected = oldItem ? oldItem.Selected === true : false;
      item.Checked = oldItem ? oldItem.Checked : false;

      this.defaultList.mainItems = this.defaultList.mainItems.set(index, item);
    } else {
      item.Selected = false;
      item.Checked = false;

      this.defaultList.mainItems = this.defaultList.mainItems.push(item);
    }
  }

  ngAfterViewInit() {

    
    setTimeout(() => {
      this.defaultList.filterComponent = this.filterFak;   
      this.filterFak.showStatusBox=true; 
      this.filterFak.ApplyFilter();
      if (this.modelData.MainList.UserRightsModelName=="ulazni-racun")
        // this.filterFak.showStatusBox=true;
      // if (this.defaultList.mainItems != null)
        this.filterFak.CheckInputDocumentAndRefreshStatusClick();       
        this.filterFak.StatusRefreshTime=new Date();
        this.filterFak.loadingFilter = false;
        this.loading = false;
        this.filterFak.SetStatusDescription();
        this.filterFak.collapsed1=true;
        this.filterFak.filterFormGroup.enable();
      }, 1000);

    // Periodična provera inicijalizacije defaultList
    const intervalCheck = setInterval(() => {
      if (this.defaultList.mainItems) {
          clearInterval(intervalCheck); // Prekini proveru kada se inicijalizuje
          const brojDanaZaProveru = 5;
          this.checkInputDocumentAndRefreshStatus(brojDanaZaProveru);
      }
  }, 100); // Provera na svakih 100ms

  }

  prevod;

  async OsveziStatus(id, silent) {
    if (this.defaultList.mainItems.find((x) => x.ID === id).OsvezivogStatusa) {
      let idParameter = [new QueryParameter("id", id)];
      // this.baseDataService
      //   .Get(
      //     "UlazniDokumentDobavljaca",
      //     "OsveziStatus",
      //     idParameter,
      //     UlazniDokumentDobavljacaView
      //   )
      //   .subscribe((data: UlazniDokumentDobavljacaView[]) => {
      //     if (data != null) this.tabsContainerService.EmitItem(data[0]);
      //   });

      const refreshedItem: any = await this.baseDataService 
            .Get("UlazniDokumentDobavljaca","OsveziStatus",idParameter, UlazniDokumentDobavljacaView)
            .toPromise();
      // this.tabsContainerService.EmitItem(refreshedItem[0]);
      if (refreshedItem && refreshedItem.length > 0) {
        if (silent) {
          this.defaultList.UpdateMainItemWithoutSelectionChange(refreshedItem[0]);
        } else {
          this.tabsContainerService.EmitItem(refreshedItem[0]);
        }
      }

    } else {
      if (!silent) {
        this.translateService
          .get("EDOKUMENT.STATUS.NEMOZEDAOSVEZI")
          .subscribe((translate) => {
            // window.alert(translate);
            this.prevod = translate
            this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              this.prevod,
              "alert",
              ConfirmationDialogButtons.Ok
            );
          });
      }
    }
  }

 
  SelektovanRacun($selektovani: any): void {
    this.poslednjiSelektovaniRacun=$selektovani;
    if (!this.osvezavanjeUToku)
    {
      const blankpdf = new Blob(["assets/pdfs/blank.pdf"]);
 
        if ($selektovani != null) {
          let _id: number = $selektovani.ID;
          this.baseDataService
            .GetFile("UlazniDokumentDobavljaca", "GetPdf", { FakDokumentID: _id })
            .subscribe(async (result: Blob) => {
              var reader = new FileReader();
              var reader1 = new FileReader();              
              let _mainThis = this;
              reader.onload = function(e) {
                try {
                  _mainThis.pdfSrc= reader.result as string;
                } catch (error) {
                  reader1.onload = function(e) {
                    _mainThis.pdfSrc= reader1.result as string; 
                  }
                  reader1.readAsText(blankpdf);
                  console.log("Ušao u catch"+error)
                }
              }
              reader.readAsText(result);
            });
        }
        else
          console.log("Ušao u else"+$selektovani)
  
      // }, 500);
    }
  }

  ContextMenuClicked(contextMenuItem: TableContextMenuItem) {  
  
    if (contextMenuItem.Action == "OsveziStatus") {
      let id: number = contextMenuItem.ID;
      this.OsveziStatus(id, false);
    }    
    if (contextMenuItem.Action == "AcceptDocument") {
      let id: number = contextMenuItem.ID;
      this.AcceptRejectDocument(id, true);
    }
    if (contextMenuItem.Action == "RejectDocument") {
      let id: number = contextMenuItem.ID;
      this.AcceptRejectDocument(id, false);
    }
    if (contextMenuItem.Action == "IzmeniKomitenta") {
      let id: number = contextMenuItem.ID;
      this.IzmeniKomitenta(id);
    }
    if (contextMenuItem.Action == "PrebaciUTroskove") {
      let id: number = contextMenuItem.ID;
      this.PrebaciUTroskove(id);
    }
  }

  ContextMenuOfTableClicked(contextMenu: TableContextMenu) {
    if (contextMenu.Action == "PrebaciUTroskove") {
      this.PrebaciSelektovaneUTroskove();
    }
  }

  Prebaci

  AcceptRejectDocument(id: number, accept){   
    let idParameter = [new QueryParameter("id", id)];
    this.baseDataService
    .GetByID("UlazniDokumentDobavljaca", id, UlazniDokumentDobavljaca)
    .toPromise().then((item: UlazniDokumentDobavljaca) => {
      this.baseDataService
    .Get(
      "UlazniDokumentDobavljaca",
      "OsveziStatus",
      idParameter,
      UlazniDokumentDobavljacaView
    ).toPromise().then((data: UlazniDokumentDobavljacaView[]) => {
      let tooltip = data[0].StatusTooltip;
      let statusGenericName = data[0].StatusGenericName;
      if (tooltip != item.StatusTooltip){
        let statusForAccept="sent, seen, rejected, renotified";
        let statusForReject="sent, seen, renotified";
        let dodatnaPoruka = "";

        if (accept && statusForAccept.includes(statusGenericName))
          dodatnaPoruka = "EDOKUMENT.CHANGEDSTATUS.TRYACCEPT";

        if (!accept && statusForReject.includes(statusGenericName))
          dodatnaPoruka = "EDOKUMENT.CHANGEDSTATUS.TRYREJECT";

        this.translateService.get([tooltip,"EDOKUMENT.CHANGEDSTATUS.NOTIFICATION",dodatnaPoruka]) 
          .subscribe(translate => {
            this.modalService.ShowConfirmationDialog(
              translate["EDOKUMENT.CHANGEDSTATUS.NOTIFICATION"],
              translate[tooltip] + " " + translate[dodatnaPoruka],
              "alert",
              ConfirmationDialogButtons.Ok
            );   

            this.OsveziStatus(id, false);
            
          })
          return false;
        }   
      this.getProvajderGenericName(item.ProvajderID).subscribe(
        (genericName: any) => {
          if (
            genericName == "Docloop_t" ||
            genericName == "Docloop_p" ||
            genericName == "Sef_t" ||
            genericName == "Sef_p"
          ) {
            let idParameter = new QueryParameter("fakDokumentId", id);
            let naslovParameter = new QueryParameter(
              "naslov",
              accept ? "COMMENT.ACCEPT.SINGULAR" : "COMMENT.REJECT.SINGULAR"
            );
            let label1Parameter = new QueryParameter(
              "labela1",
              accept ? "COMMENT.ACCEPT.REASON.SINGULAR" : "COMMENT.REJECT.REASON.SINGULAR"
            );           
            let brojParameter = new QueryParameter(
              "brojDokumenta",
              item.BrojUlaznogDokumentaDobavljaca
            );
            let acceptParameter = new QueryParameter("accept", accept);

            let modelData = new ModelData(null);
            modelData.ModalSize = ModalSize.Md;
            modelData.UpdateComponent = CommentComponent;

        if (modelData){
          this.modalService.ShowModal(0, modelData, null, true, [
            naslovParameter,
            label1Parameter,
            null,
            acceptParameter,
            brojParameter
          ])
          .result.then(
            (result) => { 
            if (result && result != ""){
              let _result : string = result;
              let acceptCommentParameter = new QueryParameter("acceptComment", _result.split(';')[0] == '' ? 'null' : _result.split(';')[0]);
              let acceptParameter = new QueryParameter("accept", accept ? "1" : "0");
              let translateAcceptReject : string = accept ? 'EDOKUMENT.ACCEPTDOCUMENT.SUCCESS' : 'EDOKUMENT.REJECTDOCUMENT.SUCCESS'
              this.baseDataService
              .Get("UlazniDokumentDobavljaca", "AcceptRejectDocument", [idParameter, acceptParameter, acceptCommentParameter], null)
              .subscribe(
                (poruka: any) => {
                this.translateService
                .get([translateAcceptReject])
                .subscribe(translate => {
                  setTimeout(()=>{
                    // this.notificationService.success(translate[translateAcceptReject], poruka);
                    this.toastrService.success(translate[translateAcceptReject], poruka);
                  }, 0)
                  this.OsveziStatus(id, false);
                });        
              }
              ,error => {
                throw error;       
              }
              
              );
            }
          },
          (reason) => {}
          );
          } else {
            this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              "Ova opcija trenutno nije implementirana za SEF.",
              "alert",
              ConfirmationDialogButtons.Ok
            );
          }
        }
      }
      );
    });
  });  
  }

  IzmeniKomitenta(id: number){
    this.baseDataService
    .GetByID("UlazniDokumentDobavljaca", id, UlazniDokumentDobavljaca)
    .subscribe((item: UlazniDokumentDobavljaca) => {
      let komitentID = item.KomitentID;
      let komitentParam = new QueryParameter("komitentId", komitentID)
      //showModal
      let modelData = new ModelData(null);
      modelData.ModalSize = ModalSize.Md;
      modelData.UpdateComponent = IzmeniKomitentaComponent;

      if (modelData){
        this.modalService.ShowModal(0, modelData, null, true, [komitentParam])
        .result.then(
          //ako je ok, ide poziv update za ulazni dokument
          (result) => { 
            if (result){
              item.KomitentID = Number(result);
              //this.baseDataService.Save("UlazniDokumentDobavljaca", item, this.modelData.MainList.ModelClass, this.modelData.MainList.ShortModelClass)
              //.subscribe((data: any) => {
              //  if (data != null) this.tabsContainerService.EmitItem(data);
              //});
              let parameters = { 'ID': id, 'KomitentID': item.KomitentID };

              this.baseDataService.Post("UlazniDokumentDobavljaca", "IzmeniKomitenta", parameters, this.modelData.MainList.ShortModelClass)
                .subscribe((data: UlazniDokumentDobavljacaView[]) => {
                  if (data != null) this.tabsContainerService.EmitItem(data[0]);
                });
            }
          })
          
        }
        
      
      }
    );
}

PrebaciUTroskove(id: number){
  let idParameter = [new QueryParameter("id", id)];
  this.baseDataService.Get("UlazniDokumentDobavljaca", "PrebaciUTroskove", idParameter, TrosakDokumentView)
    .subscribe((data: TrosakDokumentView[])=>{
      if (data){
      this.translateService.get(['ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.OBAVESTENJE','ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.NOVITROSAK'])
      .subscribe(translate =>{        
        this.modalService.ShowConfirmationDialog(
          translate['ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.OBAVESTENJE'],
          translate['ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.NOVITROSAK'] + data[0].BrojDokumenta,
          "info",
          ConfirmationDialogButtons.Ok
        );
        this.baseDataService.Get("UlazniDokumentDobavljaca","GetById", idParameter, UlazniDokumentDobavljacaView)
        .subscribe((data: any) =>{
          this.tabsContainerService.EmitItem(data);
        })
        
      })
      
    }
  })

}

  async PrebaciSelektovaneUTroskove() {
    let items: List<UlazniDokumentDobavljacaView> = this.defaultList.defaultTable.Items;
    let brojKreiranihTroskova: number = 0;
    const promises = items
      .filter(item =>
        item.Checked &&
        (item.ProvajderID === 1 || item.ProvajderID === 2 || item.ProvajderID === 3 || item.ProvajderID === 4) &&
        item.StatusGenericName === "approved" &&
        !item.Trosak
      )
      .map(async item => {
        let idParameter = [new QueryParameter("id", item.ID)];
        const data = await this.baseDataService
          .Get("UlazniDokumentDobavljaca", "PrebaciUTroskove", idParameter, TrosakDokumentView)
          .toPromise();

        if (data) {
          brojKreiranihTroskova++;
          const refreshedItem: any = await this.baseDataService
            .Get("UlazniDokumentDobavljaca", "GetById", idParameter, UlazniDokumentDobavljacaView)
            .toPromise();
          this.tabsContainerService.EmitItem(refreshedItem);
        }

      });

    await Promise.all(promises);

    this.translateService.get(['ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.OBAVESTENJE',
      'ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.BROJNOVIHTROSKOVA'])
      .subscribe(translate => {
        this.modalService.ShowConfirmationDialog(
          translate['ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.OBAVESTENJE'],
          translate['ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.BROJNOVIHTROSKOVA'] + ': ' + brojKreiranihTroskova.toString(),
          "info",
          ConfirmationDialogButtons.Ok
        );

      })
  }


PreuzmiPriloge():void {
  let _edokumentId = this.poslednjiSelektovaniRacun["EdokumentID"];
  let _brojDokumenta = this.poslednjiSelektovaniRacun["BrojUlaznogDokumentaDobavljaca"];
  this.baseDataService.GetFile("UlazniDokumentDobavljaca","PreuzmiPriloge",Number(_edokumentId))
  .subscribe((response : Blob)=>{
      let filename = 'downloaded_file';
      const fileType = response.type; // Dobijamo MIME tip
      if (fileType === 'application/pdf') {
        filename = _brojDokumenta.replace("/","-");
      } else if (fileType === 'application/zip') {
        filename = _brojDokumenta.replace("/", "-") + '.zip';
      }
      saveAs(response, filename);
  },
  error =>{
    //console.error("Greška pri preuzimanju fajla", error);
    let _message;
    let translatedMessage: string = "";
    if (error instanceof HttpErrorResponse) {
      _message = this.errorService.getServerMessage(error);
      if (_message instanceof ArrayBuffer) {
        _message = String.fromCharCode.apply(null, new Uint8Array(_message));
        let message: string = _message;
        if (message.includes("EDOKUMENT")) {
          let messageArray: string[] = message.split(';');
          messageArray.forEach((element, index) => {
            messageArray[index] = "FW.ERRORS." + element;
          });
          this.translateService.get(messageArray)
            .subscribe(translate => {
              translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
            });
        }
        else
          translatedMessage = message;
      }
      else {
        translatedMessage = this.errorService.getClientMessage(error);
      }
    }
    this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

  }
)
}

  getProvajderGenericName(id: number) {
    var parameters = [];
    var provajderId = new QueryParameter();
    provajderId.Name = "id";
    provajderId.Value = id;
    parameters.push(provajderId);

    return this.baseDataService.Get(
      "Provajder",
      "getGenericName",
      parameters,
      null
    );
  }
}



